import React, { FormEvent, useContext, useEffect } from "react";
import { useState } from "react";
import {
  Grid,
  Tab,
  Form,
  Input,
  Select,
  Button,
  Table,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import MobileStore from "../../../app/stores/mobileStore";
import { IProjectScope } from "../../../app/models/projectscope";

const MobileScopeTab = () => {
  const mobileStore = useContext(MobileStore);
  const {
    project,
    projectscopes,
    loadProjectScopes,
    createProjectScope,
    target,
  } = mobileStore;

  useEffect(() => {
    loadProjectScopes(project!.id);
  }, []);

  const [projectScope, setProjectScope] = useState<IProjectScope>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    description: "Scope submitted",
    type: "",
    status: "",
    remark: "",
  });

  return (
    <Tab.Pane>
      {projectscopes.map((projectScope) => (
           <div> {projectScope.description} on {projectScope.createdAt} </div>
          ))}
      <Button
          onClick={() => createProjectScope(projectScope)}
          // floated="right"
          positive
          content={(project!.status === "Quotes Not Yet Submitted") ? "Submit" : "Re-submit"}
          // disabled={(project!.status !== "Quotes Not Yet Submitted")}
        />
    </Tab.Pane>
  );
};

export default observer(MobileScopeTab);
